import { ConfigParams } from '../config-types';

export const ProductUrlConfig: Array<ConfigParams> = [
  {
    Page: 'REL产品与解决方案二级目录',
    PCURL: '/product/b2bCategoryChannel',
    PCDynamicUrl: '/product/[...all]',
    PCURLParams: [
      {
        ParamsName: 'code',
        ParamsType: 'query',
        FixedValue: '006001', // 默认笔记本
      },
    ],
    WapURL: '/mobile/product/channel',
    WapURLParams: [
      {
        ParamsName: 'channelActive',
        ParamsType: 'query',
        FixedValue: '1',
        MatchedUrlFn: (params) => {
          return params.channelActive == '1';
        },
      },
    ],
  },
  {
    Page: 'REL产品与解决方案三级目录',
    PCURL: '/product/b2bProductList',
    PCDynamicUrl: '/product/[...all]',
    PCURLParams: [
      {
        ParamsName: 'code',
        ParamsType: 'query',
        MatchedUrlFn: (params) => {
          return params.code.length < 12;
        },
      },
      {
        ParamsName: 'type',
        ParamsType: 'query',
      },
    ],
    WapURL: '/mobile/product/channel',
    WapURLParams: [
      {
        ParamsName: 'channelActive',
        ParamsType: 'query',
        FixedValue: '1',
      },
      {
        ParamsName: 'productActive',
        ParamsType: 'query',
      },
    ],
  },
  {
    Page: 'REL产品与解决方案系列',
    PCURL: '/product/b2bProductList',
    PCDynamicUrl: '/product/[...all]',
    PCURLParams: [
      {
        ParamsName: 'code',
        ParamsType: 'query',
        MatchedUrlFn: (params) => {
          return params.code.length == 12;
        },
      },
      {
        ParamsName: 'type',
        ParamsType: 'query',
        FixedValue: '1',
      },
    ],
    WapURL: '/mobile/product/series',
    WapURLParams: [
      {
        ParamsName: 'code',
        ParamsType: 'query',
      },
    ],
  },
  {
    Page: 'REL产品与解决方案详情',
    PCURL: '/product/b2bProductDetails',
    PCDynamicUrl: '/product/[...all]',
    PCURLParams: [
      {
        ParamsName: 'code',
        ParamsType: 'query',
      },
    ],
    WapURL: '/mobile/product/details/channel',
    WapURLParams: [
      {
        ParamsName: 'code',
        ParamsType: 'query',
      },
    ],
  },
  {
    Page: 'SMB产品与解决方案列表',
    PCURL: '/product/ProductsRecommend/ProductSearch',
    PCDynamicUrl: '/product/[...all]',
    PCURLParams: [
      {
        ParamsName: 'pageType',
        ParamsType: 'query',
        FixedValue: '0',
      },
      {
        ParamsName: 'categoryCode',
        ParamsType: 'query',
        FixedValue: '0101',
      },
    ],
    WapURL: '/mobile/product/channel',
    WapExtraUrl: ['/mobile/product'],
    WapURLParams: [
      {
        ParamsName: 'channelActive',
        ParamsType: 'query',
        FixedValue: '0',
        MatchedUrlFn: (params) => {
          return params.channelActive == '0';
        },
      },
      {
        ParamsName: 'productActive',
        ParamsType: 'query',
        FixedValue: '0',
      },
    ],
  },
  {
    Page: 'SMB产品与解决方案列表',
    PCURL: '/product/ProductsRecommend/ProductSearch',
    PCDynamicUrl: '/product/[...all]',
    PCURLParams: [
      {
        ParamsName: 'pageType',
        ParamsType: 'query',
        FixedValue: '0',
      },
      {
        ParamsName: 'categoryCode',
        ParamsType: 'query',
        FixedValue: '0101',
      },
    ],
    WapURL: '/mobile/product',
  },
];
